import React, { useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';

import DefaultModal from 'components/Modal/DefaultModal';
import AccountsListTable from './AccountsListTable';

const getStatus = (percent) => {
  if (percent < 0.51) return { color: '#e74c3c', label: 'Precisa de suporte' };
  if (percent <= 0.75) return { color: '#f1c40f', label: 'Dentro da média' };
  return { color: '#27ae60', label: 'Performando bem' };
};

const getColumns = (onOpenModal) => [
  {
    dataField: 'responsibleName',
    text: 'Responsável',
    formatter: (cell) => cell || 'Sem responsável',
    headerAlign: 'center',
    align: 'center'
  },
  {
    dataField: 'activeCount',
    text: 'Contas Ativas',
    headerAlign: 'center',
    align: 'center',
    formatter: (cell, row) => (
      <span
        style={{
          display: 'inline-block',
          width: '100%',
          cursor: Number(row.activeCount) === 0 ? 'not-allowed' : 'pointer'
        }}
        onClick={() =>
          Number(row.activeCount) > 0 && onOpenModal('active', row)
        }
        title={Number(row.activeCount) > 0 ? 'Ver contas ativas' : ''}
      >
        {row.activeCount}
      </span>
    )
  },
  {
    dataField: 'inactiveCount',
    text: 'Contas Inativas',
    headerAlign: 'center',
    align: 'center',
    formatter: (cell, row) => (
      <span
        style={{
          display: 'inline-block',
          width: '100%',
          cursor: Number(row.inactiveCount) === 0 ? 'not-allowed' : 'pointer'
        }}
        onClick={() =>
          Number(row.inactiveCount) > 0 && onOpenModal('inactive', row)
        }
        title={Number(row.inactiveCount) > 0 ? 'Ver contas inativas' : ''}
      >
        {row.inactiveCount}
      </span>
    )
  },
  {
    dataField: 'total',
    text: 'Total de Contas',
    headerAlign: 'center',
    align: 'center'
  },
  {
    dataField: 'percentLabel',
    text: '% Ativas',
    headerAlign: 'center',
    align: 'center'
  },
  {
    dataField: 'status',
    text: 'Status',
    headerAlign: 'center',
    align: 'center',
    formatter: (cell) => (
      <div
        title={cell.label}
        style={{
          display: 'inline-block',
          width: 24,
          height: 24,
          backgroundColor: cell.color,
          border: '2px solid #ccc'
        }}
      />
    )
  }
];

const AccountsStatusTable = ({ accountsCountBySeller }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalAccounts, setModalAccounts] = useState([]);

  if (!accountsCountBySeller) return null;

  const data = accountsCountBySeller.map((item) => {
    const total = Number(item.activeCount) + Number(item.inactiveCount);
    const percent = total ? Number(item.activeCount) / total : 0;
    const percentLabel = (percent * 100).toFixed(2) + '%';
    const status = getStatus(percent);
    return {
      ...item,
      total,
      percentLabel,
      status
    };
  });

  const handleOpenModal = (type, row) => {
    let accounts = [];
    let title = '';
    if (type === 'active') {
      accounts = row.activeAccounts || [];
      title = `Contas Ativas - ${row.responsibleName || 'Sem responsável'}`;
    } else {
      accounts = row.inactiveAccounts || [];
      title = `Contas Inativas - ${row.responsibleName || 'Sem responsável'}`;
    }
    setModalAccounts(accounts);
    setModalTitle(title);
    setIsModalOpen(true);
  };

  return (
    <>
      <ToolkitProvider
        keyField="responsibleLogin"
        data={data}
        columns={getColumns(handleOpenModal)}
      >
        {(props) => (
          <div className="py-4 table-responsive">
            <BootstrapTable
              {...props.baseProps}
              bootstrap4={true}
              bordered={false}
              classes="align-items-center text-center"
              headerWrapperClasses="text-center"
            />
          </div>
        )}
      </ToolkitProvider>
      <DefaultModal
        show={isModalOpen}
        onModalToggle={setIsModalOpen}
        title={modalTitle}
        showCloseButton={false}
        modalContainerClasses=""
      >
        <AccountsListTable accounts={modalAccounts} title={modalTitle} />
      </DefaultModal>
    </>
  );
};

export default AccountsStatusTable;
